// Avatar catalog: 6 categories × 10, all served from the app itself (public/assets/avatars) so they always load.
// People / pets / robots / animals are generated by scripts/gen_avatars.py; flags are static PNGs.
const local = (cat, n) => `/assets/avatars/${cat}/${n}.png`;

const MEN = ["Marcus", "Kai", "Rafael", "Oscar", "Theo", "Hugo", "Elliot", "Jasper", "Leo", "Felix"];
const WOMEN = ["Amara", "Maya", "Nadia", "Celeste", "Luna", "Zoe", "Freya", "Sienna", "Iris", "Elodie"];
const PETS = ["Biscuit", "Pumpkin", "Whiskers", "Oreo", "Clover", "Rio", "Peanut", "Smokey", "Pickles", "Bubbles"];
const ROBOTS = ["Unit7", "Pixel", "Volt", "Cog", "Nimbus", "Bleep", "Rivet", "Axiom", "Sprocket", "Zed"];
const ANIMALS = ["Lion", "Tiger", "Panda", "Koala", "Fox", "Owl", "Elephant", "Penguin", "Kangaroo", "Wolf"];
const FLAGS = [["au", "Australia"], ["nz", "New Zealand"], ["gb", "United Kingdom"], ["us", "United States"], ["ca", "Canada"], ["ie", "Ireland"], ["za", "South Africa"], ["in", "India"], ["ph", "Philippines"], ["fj", "Fiji"]];

const group = (id, label, cat, prefix, names) => ({ id, label, items: names.map((n, i) => ({ id: `${prefix}_${i + 1}`, label: n, url: local(cat, i + 1) })) });

export const AVATAR_CATEGORIES = [
  group("men", "Men", "men", "man", MEN),
  group("women", "Women", "women", "woman", WOMEN),
  group("pets", "Pets", "pets", "pet", PETS),
  group("animals", "Animals", "animals", "animal", ANIMALS),
  group("robots", "Robots", "robots", "robot", ROBOTS),
  { id: "flags", label: "Flags", items: FLAGS.map(([cc, n], i) => ({ id: `flag_${i + 1}`, label: n, url: `/assets/avatars/flags/${cc}.png` })) },
];

const BY_ID = Object.fromEntries(AVATAR_CATEGORIES.flatMap((c) => c.items.map((a) => [a.id, a.url])));
export const DEFAULT_AVATAR = local("men", 1);
// unknown / legacy ids (e.g. the retired emoji set) fall back to the default so a seat never shows a broken image
export const avatarSrc = (id) => BY_ID[id] || DEFAULT_AVATAR;
export const AVATAR_IDS = Object.keys(BY_ID);
